import React, {useContext} from 'react';
import {RelationColumn} from '../../src/components/List/columns/RelationColumn';
import {IListConfigRelationColumn} from '../../src/@interfaces/components/List/IListConfigRelationColumn';
import {ListConfigNamedColumn} from '../../src/@types/components/List';
import {IListColumnProps} from '../../src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '../../src/@interfaces/models/Order/IOrderModel';
import {parseDate} from '../../src/helpers/dates';
import CountDown from '../../src/components/Timer/CountDown';
import {LocaleContext} from '../../src/contexts/LocaleContext';
import OrderStatusRepresentation from '../../src/components/StatusRepresentations/OrderStatusRepresentation';

export default function OrderListStatusColumn(
        props: IListColumnProps<ListConfigNamedColumn<IListConfigRelationColumn>, IOrderModel>
) {
    useContext(LocaleContext);
    const willExpiredAt = props.model.status_will_be_expired_at;

    return <>
        <OrderStatusRepresentation
                bgColor={props.model?.status_bg_color}
                textColor={props.model?.status_text_color}
        >
            <RelationColumn {...props}/>
        </OrderStatusRepresentation>

        {willExpiredAt ? <CountDown expiredAt={parseDate(willExpiredAt)}/> : null}
    </>;
}
